import { render, staticRenderFns } from "./Configure.vue?vue&type=template&id=0fad8a53&scoped=true&"
import script from "./Configure.vue?vue&type=script&lang=js&"
export * from "./Configure.vue?vue&type=script&lang=js&"
import style0 from "./Configure.vue?vue&type=style&index=0&id=0fad8a53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fad8a53",
  null
  
)

export default component.exports